import { useMutation } from '@tanstack/react-query';
import { subscribe, cancelSubscription } from './request';
import toast from 'react-hot-toast';

export const useSubscribe = (
  onSuccess?: (data: Awaited<ReturnType<typeof subscribe>>) => void
) => {
  return useMutation({
    mutationFn: subscribe,
    onSuccess: (data) => {
      toast.success(data.response);
      onSuccess?.(data);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to subscribe');
    },
  });
};

export const useCancelSubscription = (
  onSuccess?: (data: Awaited<ReturnType<typeof cancelSubscription>>) => void
) => {
  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: (data) => {
      toast.success(data.response);
      onSuccess?.(data);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to cancel subscription');
    },
  });
};
